import { environment } from '../../environments/environment';
import { Site } from '../models/site';


export class SiteTools {
  static longitude(site: Site): number {
    if(site.pin) {
      const position = Cesium.Cartesian3.fromArray(site.pin);
      const carto = Cesium.Ellipsoid.WGS84.cartesianToCartographic(position);
      return Cesium.Math.toDegrees(carto.longitude);
    }
    return 0;
  }

  static latitude(site: Site): number {
    if(site.pin) {
      const position = Cesium.Cartesian3.fromArray(site.pin);
      const carto = Cesium.Ellipsoid.WGS84.cartesianToCartographic(position);
      return Cesium.Math.toDegrees(carto.latitude);
    }
    return 0;
  }

  static modelTilesetUrl(site: Site, batchId: string): string | undefined {
    if(site.lastBatch) {
      return environment.apiUrl + '/organizations/' + site.organization + '/sites/' + site.id + '/batchs/' + batchId + '/tilesets/tiles/model/tileset.json'
    }
    return undefined;
  }

  static pntsTilesetUrl(site: Site, batchId: string): string | undefined {
    if(site.lastBatch) {
      return environment.apiUrl + '/organizations/' + site.organization + '/sites/' + site.id + '/batchs/' + batchId + '/tilesets/tiles/pnts/tileset.json'
    }
    return undefined;
  }

}
